import React from 'react';
import { observer } from 'mobx-react';
import Select from '../../../inputs/simpleComponents/Select';
const CssDimensionNumberInput = observer(({
  value,
  unit,
  setValue,
  title = ''
}) => {
  const updateVal = (val, unit) => {
    setValue(val, unit);
  };
  return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
    className: "css-number-input"
  }, /*#__PURE__*/React.createElement("span", {
    className: "css-number-input-with-title"
  }, /*#__PURE__*/React.createElement("input", {
    type: "number",
    value: value,
    onChange: e => {
      updateVal(e.target.value, unit);
    },
    onBlur: e => {
      let newVal = e.target.value;
      if (e.target.value === '') {
        newVal = '0.0';
      }
      updateVal(parseFloat(newVal), unit);
    }
  })), /*#__PURE__*/React.createElement(Select, {
    elements: [{
      label: 'px',
      value: 'px'
    }, {
      label: '%',
      value: '%'
    }],
    defaultValue: unit,
    onChangeSelect: u => {
      updateVal(value, u);
    }
  })), /*#__PURE__*/React.createElement("span", {
    className: "css-number-input-title"
  }, title));
});
export default CssDimensionNumberInput;